import { Directive, Input, ElementRef, Renderer2, OnChanges, SimpleChanges, OnInit } from '@angular/core';

@Directive({
  selector: '[loadingView]'
})
export class LoadingDirective implements OnChanges, OnInit {

  @Input() loadingState: boolean = false;

  @Input() opacityCss: any = {
    "opacity": "0.5", 
    "filter": "alpha(opacity=50)", /* For IE8 and earlier */
    "position": "relative"
  };
	@Input() image = "assets/images/loadingImage.gif";			//You can change this anytime anyday based on your image location.
	@Input() imageClassName:any = "loadingImage";
	@Input() imageStyle = "left:0; right:0; margin:0 auto; position:absolute; top:25%; width:30%; height:auto;";

  constructor(private renderer: Renderer2, private el: ElementRef) { 
    
  }

  ngOnInit() {
    this.toggleIsloading();
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.loadingState){
     this.toggleIsloading();
    }
  }
  
  isLoadingAlready(){
    let className = "img."+this.imageClassName;
    var hasChild = this.el.nativeElement.querySelector(className) != null;
    return hasChild;
  }

  toggleIsloading(){
    let loadingImage = this.createLoadingImage();
    if (this.loadingState==true){      
      if (!this.isLoadingAlready()){
        for (const [style, value] of Object.entries(this.opacityCss)) {
          this.renderer.setStyle(this.el.nativeElement, style, value);
        }      
        this.renderer.appendChild(this.el.nativeElement, loadingImage);
      }
    }
    else{
      for (const [style, value] of Object.entries(this.opacityCss)) {
        this.renderer.removeStyle(this.el.nativeElement, style);
      }       
      this.renderer.removeChild(this.el.nativeElement, loadingImage);
    }
  }

  createLoadingImage():any{
    let img = this.renderer.createElement("img");
    this.renderer.setAttribute(img, "src", this.image);
    this.renderer.setAttribute(img, "alt", "loading...");
    this.renderer.setAttribute(img, "style", this.imageStyle);
    this.renderer.addClass(img, this.imageClassName);
    return img;
  }


}
